<auto-main-navigation [accountId]="accountId"></auto-main-navigation>

<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">Pages</h1>
  </p-header>
  @if (isLoaded) {
    <div class="main-content-wrapper">
      <p-panel class="p-col p-panel">
        <p-header class="add-and-filter-row">
          <p-menu #pageMenu [popup]="true" [model]="menuModel"></p-menu>
          <p-button type="button" class="p-mr-2" severity="info" icon="pi pi-plus" (click)="pageMenu.toggle($event)"></p-button>
          <div>
            <p-select class="p-mr-2"
              [style] = "{'min-width': '200px'}"
              [options] ="sortByOptions"
              [(ngModel)]="selectedSortOption"
              (onChange)="showPages()">
            </p-select>
          </div>
          <div>
            <p-toggleButton
              onIcon="pi pi-arrow-circle-up"
              offIcon="pi pi-arrow-circle-down"
              offLabel="Descending"
              onLabel="Ascending"
              [(ngModel)]="arrowUp"
              (onChange)="showPages()">
            </p-toggleButton>
          </div>
          <div>
            <label class="show-label">Show: </label>
            <p-select class="p-mr-2"
              [style] = "{'min-width': '200px'}"
              [options] ="showOptions"
              [(ngModel)]="selectedShowOption"
              (onChange)="showPages()">
            </p-select>
          </div>
          <p-iconField iconPosition="left" class="input-bar">
            <p-inputIcon class="pi pi-search"></p-inputIcon>
            <input type="text" pInputText [(ngModel)]="pageSearchFilter" placeholder="Search Pages..." />
          </p-iconField>
          <p-dialog header="Project Page" [(visible)]="displayProjectPageModal" modal="true"
            [draggable]="false" [dismissableMask]="true" [resizable]="false" (onHide)="closeModal()">
            <div class="input-wrapper">
              <label for="mpop-accounts" class="field-input-label input-label">Account</label>
              <p-select
                pTooltip="Pages can only be projected from one account at a time."
                [tooltipDisabled]="!accountDropdownDisabled"
                tooltipPosition="top"
                id="mpop-accounts"
                appendTo="body"
                aria-label="Account"
                [options]="compactOEMAccounts"
                [ngModel]="selectedAccount"
                [disabled]="accountDropdownDisabled"
                (ngModelChange)="onAccountSelected($event)"
                optionLabel="name"
                placeholder="Account"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
              </p-select>
            </div>
            <div class="input-wrapper">
              <label for="pages" class="field-input-label input-label">Pages</label>
              @if (accountPages[0].items.length > 0) {
                <p-multiSelect
                  #pagesDropdown
                  id="pages"
                  appendTo="body"
                  aria-label="Page"
                  [options]="accountPages"
                  [(ngModel)]="selectedAccountPageIds"
                  [group]="true"
                  resetFilterOnHide="true"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="pagesDropdownDisabled ? 'Loading...' : 'Page'"
                  class="pages-dropdowns"
                  [disabled] = "pagesDropdownDisabled"
                  (onChange)="toggleAccountDropdownDisabled()"
                  [style]="{'width':'33rem', 'padding':'0.5rem'}">
                  <ng-template let-group pTemplate="group">
                    <div class="p-d-flex p-ai-center">
                      <span>{{group.label}}</span>
                    </div>
                  </ng-template>
                </p-multiSelect>
              } @else {
                <p-multiSelect
                  #pagesDropdown
                  id="pages"
                  appendTo="body"
                  [options]="accountPages"
                  [group]="true"
                  [disabled] = "pagesDropdownDisabled"
                  [placeholder]="pagesDropdownDisabled ? 'Loading...' : 'Page'"
                  [style]="{'width':'33rem', 'padding':'0.5rem'}">
                </p-multiSelect>
              }
            </div>
            <div class="modal-button-wrapper">
              <button type="button" pButton (click)="projectPage()" icon="pi pi-check" class="p-button-success modal-button" label="Confirm"></button>
            </div>
          </p-dialog>
          <!-- Import Page Modal -->
          <p-dialog header="Import Page" (onHide)="closeModal()" [(visible)]="displayImportPageModal" modal="true"
            [draggable]="false" [dismissableMask]="true" [resizable]="false">
            <div class="input-wrapper">
              <label class="field-input-label input-label">Copy from Account</label>
              <p-autoComplete
                [(ngModel)]="selectedAccount"
                [showEmptyMessage]="true"
                [suggestions]="filteredCompactAccounts"
                (completeMethod)="filterAccounts($event)"
                (onSelect)="getImportedPages()"
                (onClear)="getImportedPages()"
                optionLabel="name"
                placeholder="Search accounts..."
                [minQueryLength]="1"
                appendTo="body"
                [dropdown]="true"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
                <ng-template let-account pTemplate="item">
                  <div class="account-item">
                    <div>{{account.name}}</div>
                  </div>
                </ng-template>
              </p-autoComplete>
            </div>
            @if (importablePages.length > 0 && selectedAccount !== null) {
              <div class="input-wrapper">
                <label class="field-input-label input-label">Copy Page</label>
                <p-iconField iconPosition="left" class="input-bar">
                  <p-inputIcon class="pi pi-search"></p-inputIcon>
                  <input type="text"
                         pInputText [(ngModel)]="importSearchFilter"
                         (input)="dt.filterGlobal($event.target.value, 'contains')"
                         placeholder="Search pages..."/>
                </p-iconField>
                <br>
                  <p-table
                    class="table"
                    #dt [value] = "importablePages"
                    [(selection)]="selectedImportPages"
                    [lazy]="false"
                    [globalFilterFields]="['title', 'type']"
                    selectionMode="multiple"
                    [scrollable] ="true"
                    scrollHeight="500px">
                    <ng-template pTemplate="body" let-pages>
                      <tr [pSelectableRow]="pages">
                        <td>{{pages.title}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              }
              <div class="modal-button-wrapper">
                <button type="button" icon="pi pi-check" class="p-button-success modal-button" pButton (click)="importPage()" label="Import"></button>
              </div>
            </p-dialog>
          </p-header>
          <!-- Edit URLs Modal -->
          <p-dialog header="Edit URLs For {{pageName}}" [(visible)]="displayEditLinksModal" modal="true" [draggable]="false" [dismissableMask]="true" [resizable]="false">
            <div class="input-wrapper">
              <label for="live-url" class="field-input-label input-label">Live URL</label>
              <input type="text" pInputText [(ngModel)]="pageUrl" id="live-url" class="url-input"/>
            </div>
            <div class="input-wrapper">
              <label for="inventory-url" class="field-input-label input-label">Inventory URL</label>
              <input type="text" pInputText [(ngModel)]="inventoryUrl" id="inventory-url" class="url-input"/>
            </div>
            <div class="modal-button-wrapper">
              <button type="button" pButton (click)="editLinks()" icon="pi pi-save" class="p-button-success modal-button" label="Save"></button>
            </div>
          </p-dialog>
          <!-- Delete Page Modal -->
          <div class="modal-button-wrapper">
            <p-confirmDialog key="deleteProjectedPageModal"></p-confirmDialog>
          </div>
          <!-- Custom Page Modal -->
          <div class="modal-button-wrapper">
            <p-confirmDialog key="buildCustomPage"></p-confirmDialog>
          </div>
          <!-- Promote Page Modal -->
          <p-dialog header="Promote {{pageName}}" [(visible)]="displayPromotePageModal" modal="true" [draggable]="false" [dismissableMask]="true"
            [resizable]="false" (onHide)="resetProjectedPageAccount()">
            <div class="input-wrapper">
              <label for="mpop-accounts" class="field-input-label input-label">Account</label>
              <p-select
                pTooltip="Pages can only be projected from one account at a time."
                [tooltipDisabled]="!accountDropdownDisabled"
                tooltipPosition="top"
                id="mpop-accounts"
                appendTo="body"
                aria-label="Account"
                [options]="compactOEMAccounts"
                [(ngModel)]="selectedPromotePageAccount"
                [disabled] = "accountDropdownDisabled"
                optionLabel="name"
                placeholder="Account"
                filter="true"
                (onChange)="getPromotablePagesForAccount()"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
              </p-select>
            </div>
            <div class="input-wrapper">
              <label for="pages" class="field-input-label input-label">Page</label>
              <p-select
                id="pages"
                appendTo="body"
                aria-label="Page"
                [options]="promotablePages"
                [(ngModel)]="pageToReplace"
                optionLabel="label"
                placeholder="Page"
                filter="true"
                (onChange)="toggleAccountDropdownDisabled()"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
                <ng-template let-group pTemplate="group">
                  <div class="p-d-flex p-ai-center">
                    <span>{{group.label}}</span>
                  </div>
                </ng-template>
              </p-select>
            </div>
            <div class="modal-button-wrapper">
              <p-confirmDialog key="promotePageModal"></p-confirmDialog>
              <button type="button" pButton (click)="openConfirmPromotePageModal()" icon="pi pi-check" class="p-button-success modal-button" label="Confirm"></button>
            </div>
          </p-dialog>
          <!-- delete native page modal -->
          <p-confirmDialog key="confirmDeleteNativePageModal"></p-confirmDialog>
          <!-- copy to account modal -->
          <p-confirmDialog key="copyToAccountModal"></p-confirmDialog>
          <!-- page cards section -->
          <p-tabs value="0">
            <p-tablist>
              @for (tab of tabConfig; track tab.value) {
                <p-tab [value]="tab.value">
                  @if (tab.header === "") {
                    <span class="config-tab-header"><i class="pi pi-cog"></i></span>
                  } @else {
                    <span>{{tab.header}}</span>
                    @if (tab.header === 'Projected Pages') {
                      <p-badge [value]="(displayedProjectedPages | async | filter:pageSearchFilter)?.length.toString()" class="p-ml-3 p-badge-secondary"></p-badge>
                    }
                    @if (tab.header === 'Native Pages') {
                      <p-badge [value]="(displayedNativePages | async | filter:pageSearchFilter)?.length.toString()" class="p-ml-3 p-badge-secondary"></p-badge>
                    }
                  }
                </p-tab>
              }
            </p-tablist>
            @for (tab of tabConfig; track tab) {
              @if (tab.type === 'projected') {
                <p-tabpanel [value]="tab.value">
                  <div class="page-card-section card-row">
                    @if (isLoadingProjectedPages) {
                      <p-progressSpinner class="small-spinner"></p-progressSpinner>
                    }
                    @if (!isLoadingProjectedPages) {
                      @if ((displayedProjectedPages | async | filter:pageSearchFilter)?.length > 0) {
                        @for (page of displayedProjectedPages | async | filter:pageSearchFilter; track page) {
                          <p-card class="page-card-wrapper">
                            <ng-template pTemplate="header" class="card-header">
                              <div class="card-header-wrapper">
                                @if (page.pageUrl !== '') {
                                  <a [href]="page.pageUrl"  target="_blank" class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Live</a>
                                }
                                @if (page.pageUrl === '') {
                                  <a  pTooltip="Live URL is Empty" target="_blank" class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Live</a>
                                }
                                <a href="{{documentProtocol}}//{{documentHostname}}/pages/preview/landing/{{account.accountFolder}}/{{page.id}}/custom.htm"
                                  target="_blank" class="p-mr-2 card-link"><i
                                class="pi pi-external-link"></i> Preview</a>
                                @if (page.previewModeEnabled) {
                                  @if (page.previewModeEnvironment) {
                                    @if (page.previewModeUrl) {
                                      <a [href]="page.previewModeUrl" target="_blank" rel="noopener noreferrer"
                                        class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Preview Mode</a>
                                    } @else {
                                      <span class="p-mr-2 card-link" role="link" aria-disabled="true" tabindex="0"
                                        style="opacity: 0.6; cursor: not-allowed;"
                                        [attr.aria-label]="previewModeUnavailableMessage"
                                        [pTooltip]="previewModeUnavailableMessage" tooltipEvent="both">
                                        <i class="pi pi-external-link" aria-hidden="true"></i> Preview Mode
                                      </span>
                                    }
                                  }
                                } @else {
                                  @if (!isProduction && page.pageUrl !== '') {
                                    <a [href]="page.tokenViewUrl" target="_blank" class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Token View</a>
                                  }
                                }
                                <p-menu #menu [model]="subMenuModels[page.id]" [popup]="true"></p-menu>
                                <i class="pi pi-ellipsis-h p-mr-2" (click)="menu.toggle($event)"></i>
                                @if (page.isPrivatePage) {
                                  <i class="pi pi-lock private-page-icon" pTooltip="Private Offer Page"></i>
                                }
                                @if (!page.active) {
                                  <i class="pi pi-eye-slash inactive-page-icon" pTooltip="Page is inactive"></i>
                                }
                              </div>
                            </ng-template>
                            <a class="page-title-link"><i class="pi pi-file"></i> {{page.titleName}} </a>
                            <ng-template pTemplate="footer">
                              <div class="card-footer">
                                <p>Type: {{page.pageType}}</p>
                                <p>Last Modified: {{page.modified.date | date: 'shortDate'}}</p>
                              </div>
                            </ng-template>
                          </p-card>
                        }
                      } @else {
                        <div class="no-pages-message">
                          No Projected Pages Available
                        </div>
                      }
                    }
                  </div>
                </p-tabpanel>
              }
              @if (tab.type === 'native') {
                <p-tabpanel [value]="tab.value">
                  <div class="page-card-section card-row">
                    @if (isLoadingNativePages) {
                      <p-progressSpinner class="small-spinner"></p-progressSpinner>
                    }
                    @if (!isLoadingNativePages) {
                      @if ((displayedNativePages | async | filter:pageSearchFilter)?.length > 0) {
                        @for (page of displayedNativePages | async | filter:pageSearchFilter; track page) {
                          <p-card class="page-card-wrapper">
                            <ng-template pTemplate="header" class="card-header">
                              <div class="card-header-wrapper">
                                @if (page.pageUrl !== '') {
                                  <a [href]="page.pageUrl"  target="_blank" class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Live</a>
                                }
                                @if (page.pageUrl === '') {
                                  <a  pTooltip="Live URL is Empty" target="_blank" class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Live</a>
                                }
                                <a href="{{documentProtocol}}//{{documentHostname}}/pages/preview/landing/{{account.accountFolder}}/{{page.id}}/custom.htm"
                                  target="_blank" class="p-mr-2 card-link"><i
                                class="pi pi-external-link"></i> Preview</a>
                                @if (page.previewModeEnabled) {
                                  @if (page.previewModeEnvironment) {
                                    @if (page.previewModeUrl) {
                                      <a [href]="page.previewModeUrl" target="_blank" rel="noopener noreferrer"
                                        class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Preview Mode</a>
                                    } @else {
                                      <span class="p-mr-2 card-link" role="link" aria-disabled="true" tabindex="0"
                                        style="opacity: 0.6; cursor: not-allowed;"
                                        [attr.aria-label]="previewModeUnavailableMessage"
                                        [pTooltip]="previewModeUnavailableMessage" tooltipEvent="both">
                                        <i class="pi pi-external-link" aria-hidden="true"></i> Preview Mode
                                      </span>
                                    }
                                  }
                                } @else {
                                  @if (!isProduction && page.pageUrl !== '' && page.tokenViewUrl !== '') {
                                    <a [href]="page.tokenViewUrl" target="_blank" class="p-mr-2 card-link"><i class="pi pi-external-link"></i> Token View</a>
                                  }
                                }
                                <p-menu #menu [model]="subMenuModels[page.id]" [popup]="true"></p-menu>
                                <i class="pi pi-ellipsis-h p-mr-2" (click)="menu.toggle($event)"></i>
                                @if (page.isConnectedSource) {
                                  <i class="pi pi-sitemap projected-page-icon" pTooltip="Page is projected"></i>
                                }
                                @if (page.isPrivatePage) {
                                  <i class="pi pi-lock private-page-icon" pTooltip="Private Offer Page"></i>
                                }
                                @if (!page.active) {
                                  <i class="pi pi-eye-slash inactive-page-icon" pTooltip="Page is inactive"></i>
                                }
                              </div>
                            </ng-template>
                            <a href="{{documentProtocol}}//{{documentHostname}}/pages/{{accountId}}#/edit/{{page.id}}"
                              class="page-title-link"><i class="pi pi-file"></i>
                              {{page.titleName}}
                            </a>
                            <ng-template pTemplate="footer">
                              <div  class="card-footer">
                                <p>Type: {{page.pageType}}</p>
                                <p>Last Modified: {{page.modified.date | date:'shortDate'}}</p>
                              </div>
                            </ng-template>
                          </p-card>
                        }
                      } @else {
                        <div class="no-pages-message">
                          No Pages Available
                        </div>
                      }
                    }
                  </div>
                </p-tabpanel>
              }
              @if (tab.type === 'config') {
                <p-tabpanel [value]="tab.value">
                  <auto-page-configuration>
                  </auto-page-configuration>
                </p-tabpanel>
              }
            }
          </p-tabs>
          <p-dialog header="Select Source Page For {{pageName}}" [(visible)]="displayProjectNativePageModal" modal="true"
            [draggable]="false" [dismissableMask]="true" [resizable]="false">
            <div class="input-wrapper">
              <label for="mpop-accounts" class="field-input-label input-label">Account</label>
              <p-select
                tooltipPosition="top"
                appendTo="body"
                aria-label="Account"
                [options]="compactOEMAccounts"
                [(ngModel)]="nativeProjectionSelectedAccountId"
                optionLabel="name"
                optionValue="id"
                placeholder="Account"
                (onHide)="getPagesForAccountForNativeProjection()"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
              </p-select>
            </div>
            <div class="input-wrapper">
              <label for="pages" class="field-input-label input-label">Page</label>
              <p-select
                appendTo="body"
                aria-label="Page"
                filter="true"
                [options]="nativeProjectionAccountPages"
                [(ngModel)]="nativeProjectionSelectedParentPageId"
                [disabled]="this.disableDropdown"
                optionLabel="titleName"
                optionValue="id"
                placeholder="Page"
                class="pages-dropdowns"
                [style]="{'width':'33rem', 'padding':'0.5rem'}">
              </p-select>
            </div>
            <div class="modal-button-wrapper">
              <p-confirmDialog key="confirmProjectNativePageModal"></p-confirmDialog>
              <button type="button" pButton (click)="openConfirmProjectNativePageModal()" icon="pi pi-check" class="p-button-success modal-button" label="Confirm"></button>
            </div>
          </p-dialog>
        </p-panel>
      </div>
    }
  </p-panel>
  <auto-footer></auto-footer>
